// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"uhIDuMJQlpvmrYYIurhR","customerAttributes":"ka3r7CNFdBEjZcV9YulU"};